<template>
    <DataTable :url="api.ACTIONS.ROLES"
               :fieldsHiddenMain="['guard_name']"
               :fieldsHiddenEdit="['guard_name','permissions_count']"
               :fieldsDisabledEdit="['id','created_at','updated_at','permissions_count']"
               :fieldsHiddenAdd="['guard_name','id','created_at','updated_at','permissions_count']"
               :fieldsExtraAdd="fieldsExtraAdd"
               :fieldsExtraEdit="fieldsExtraEdit"
               :formatter="{permissions_count(value) {return JSON.stringify(value)}}"
               loadBeforeEdit
               :titles="titles"
               title="Roles"

    />
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "Roles",
        title: 'Roles',
        components: {DataTable},
        computed: {
            titles: () => ({
                "id": "#",
                "name": "Name",
                "created_at": "Created At",
                "updated_at": "Updated At",
                "permissions_count": "Permissions Count",
                "permissions": "Permissions"
            }),
            fieldsExtraAdd: () => ({
                permissions: "choose-permissions-multi"
            }),
            fieldsExtraEdit: () => ({
                permissions: "choose-permissions-multi"
            }),
        }
    }
</script>

<style scoped>

</style>